/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_SubtitleInputs */

const cs_tasks_subtitle = /** @type {(inputs: Tasks_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seznam úkolů z task.list.`)
};

const en_tasks_subtitle = /** @type {(inputs: Tasks_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task list from task.list.`)
};

/**
* | output |
* | --- |
* | "Task list from task.list." |
*
* @param {Tasks_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_subtitle = /** @type {((inputs?: Tasks_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_subtitle(inputs)
	return cs_tasks_subtitle(inputs)
});